import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-featured-offers',
  templateUrl: './featured-offers.component.html',
  styleUrls: ['./featured-offers.component.scss']
})
export class FeaturedOffersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
